import * as React from 'react';

function SvgRoleContentSpecialist(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" {...props}>
      <path
        d="M18.085 19.7c-5.502 0-9.852-4.348-9.852-9.85 0-5.5 4.35-9.85 9.852-9.85 5.502 0 9.851 4.35 9.851 9.85 0 5.267-4.35 9.85-9.851 9.85zm-4.115 1.834l9.029.333L23 39.386l2.213 1.18c-3.41.133-6.24.2-8.492.2h-.655c-3.102-.002-8.188-.017-10.114-.236 0 0-5.949-.235-5.949-4.114 0 0-.235-5.736 3.433-9.85l.036-.045c.406-.499 4.235-4.987 10.498-4.987zM41 22v14.48l-7.845 4.344L25 36.48V22h16zm-8 3.982l-1.236 2.62-2.764.422 2 2.039-.472 2.883L33 32.584l2.472 1.362L35 31.063l2-2.039-2.764-.422L33 25.982z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgRoleContentSpecialist;
